module.exports = __webpack_public_path__ + "img/our-services.18818709.webp";